import { render, staticRenderFns } from "./DocumentTemplate.vue?vue&type=template&id=ff45ff8e&scoped=true&"
import script from "./DocumentTemplate.vue?vue&type=script&lang=js&"
export * from "./DocumentTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff45ff8e",
  null
  
)

export default component.exports